import React, { useState } from 'react'
import { AccessiblePagination } from '../GenericComponents/AccessibleComponents';

function GenericPagination({ dataLength, displayLength, page, setDisplayLength, setPage, discludeAllLength, customOnChangePageLength, customOnChangeLength, removePadding }) {
    const [defaultDisplayLength, setDefaultDisplayLength] = useState(10);
    const [defaultPage, setDefaultPage] = useState(1);
    const prev = true;
    const next = true;
    const first = true;
    const last = true;
    const ellipsis = true;
    const maxButtons = 5;
    const limitOptions = (discludeAllLength || dataLength < 50) ? [10, 20, 50] : [10, 20, 50, dataLength];
    const [layout, setLayout] = useState(['limit', '|', 'total', '-', 'pager'])
    const handleChangePage = (dataKey) => {
        if (!page) {
            setDefaultPage(dataKey);
        }
        setPage(dataKey);
    }
    const handleChangeLength = (dataKey) => {
        if (!(page && displayLength)) {
            setDefaultPage(1);
            setDefaultDisplayLength(dataKey);
        }
        setPage(1);
        setDisplayLength(dataKey);
    }
    return (
        <AccessiblePagination
            ariaLabel="Pagination Label"
            style={removePadding ? { padding: '0' } : {}}
            className={"my-1"}
            limitOptions={limitOptions}
            maxButtons={maxButtons}
            ellipsis={ellipsis}
            prev={prev}
            next={next}
            first={first}
            last={last}
            layout={layout}
            activePage={page ?? defaultPage}
            limit={displayLength ?? defaultDisplayLength}
            total={dataLength}
            boundaryLinks={true}
            onChangePage={customOnChangePageLength ?? handleChangePage}
            onChangeLimit={customOnChangeLength ?? handleChangeLength} />
    )
}
export default GenericPagination;